import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import axios from "axios";
import VueAxios from "vue-axios";
import router from "./router"
import store from "./store";

Vue.config.productionTip = false
Vue.use(VueAxios, axios);

const AUTH0_DOMAIN = "https://test-auth.candidate-concierge.com/";

const client_name = "dcc-spa-client";

if(window.sessionStorage[`oidc.user:${AUTH0_DOMAIN}:${client_name}`]) {
  const token_type = JSON.parse(window.sessionStorage[`oidc.user:${AUTH0_DOMAIN}:${client_name}`]).token_type;
  const token = JSON.parse(window.sessionStorage[`oidc.user:${AUTH0_DOMAIN}:${client_name}`]).access_token;
  const headers = { Authorization: `${token_type} ${token}` };

  axios.interceptors.request.use(
    function (config) {
      config.headers = headers;
      return config;
    }
  );
}

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app');
